import {LinearScale} from "@/ui/canvas/scale"

const height = 157
const padding = 10
export const Vertical = {
    scale: new LinearScale(0, 21),
    height,
    padding,
    innerHeight: height - padding * 2
}